import styled from "styled-components";

import { IconButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { buttonTypes } from "app/UtilitiesAndConstants/Constants/ButtonTypes";

const RetailInsightsCtaLink = styled.a`
    display: inline-flex;
    text-decoration: none;
`;

export interface IRetailInsightsCtaProps {
    href?: string;
    onClick?: () => void;
    label: string;
}

export const RetailInsightsCta = ({ href, onClick, label }: IRetailInsightsCtaProps) => {
    if (!href) {
        return null;
    }

    return (
        <Flex
            alignSelf="flex-start"
            flex="0 0 auto"
            margin="12px 0 0 0"
        >
            <RetailInsightsCtaLink
                data-automation="website-performance-retail-insights-cta"
                href={href}
                rel="noopener noreferrer"
                target="_blank"
                onClick={onClick}
            >
                <IconButton
                    iconName="link-out"
                    iconSize="xs"
                    type={buttonTypes.OUTLINED}
                >
                    {label}
                </IconButton>
            </RetailInsightsCtaLink>
        </Flex>
    );
};
